import styled from 'styled-components';

const shouldForwardProp = prop => !['theme'].includes(prop);

export const OtherDeductionsStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .cardWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex-flow: wrap;
    gap: 8px;
  }

  .cardWrapper1 {
    gap: 8px;
    width: 100%;
  }
`;
